import { Card, Col, Row } from "react-bootstrap"
import { Link } from "react-router-dom"

interface OrganizationResultProps {
  data: {
    title: string,
  }[]
}

const OrganizationResult = (props: OrganizationResultProps) => {
  return (
    <>
      <Row>
        <Col>
          <Card className="contentCard">
            <Card.Header>
              <Row>
                <Col md={5}>
                  Name
                </Col>
                <Col md={4}>
                  Typ
                </Col>
                <Col md={1}>
                  PLZ
                </Col>
                <Col md={2}>
                  Ort
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              {
                // add empty div for correct zebra
              }
              <div></div>
              {props.data.map((res, index) => (
                <Row key={index} className="cardContentLine">
                  <Col md={5}>
                    <Link to={`/practice/1`} className="truncateText">{res.title}</Link>
                  </Col>
                  <Col md={4}>
                  </Col>
                  <Col md={1}>
                  </Col>
                  <Col md={2}>
                  </Col>
                </Row>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default OrganizationResult
